export enum DataSensitivityEnum {
    VeryLow = "VeryLow",
    Low = "Low",
    Medium = "Medium",
    High = "High",
    VeryHigh = "VeryHigh",
}